import {
    allFetch
} from "../Domain";

/**
 * @description 查出日期區間有點餐的客戶
 */
export const MOSReport = (() => {
    /**
     * @description 查出日期區間有點餐的客戶
     */
    const DateRangeCustomerTotal = async function (obj = {
        Plant: '',
        date_start: '',
        date_end: '',
        customer_name: '',
        contact_person: ''
    }) {
        return await allFetch('MOSReport/DateRangeCustomerTotal', obj);
    }
    /**
     * @description 查出日期區間有點餐的客戶
     */
    const DateRangeMealServiceBellCheckCarCondition = async function (obj = {
        Plant: '',
        date_start: '',
        date_end: '',
        license_plate: '',
        excel: ""
    }) {
        return await allFetch('MOSReport/DateRangeMealServiceBellCheckCarCondition', obj);
    }
    /**
     * @description 期間品項統計
     */
    const DateRangeTotal = async function (obj = {
        Plant: '',
        date_start: '',
        date_end: '',
        mg_ids: new Array(),
        m_ids: new Array(),
        excel: ""
    }) {
        return await allFetch('MOSReport/DateRangeTotal', obj);
    }
    /**
     * @description 查出日期區間有點餐的客戶的餐點明細
     */
    const DateRangeCustomerTotalDetail = async function (obj = {
        Plant: '',
        date_start: '',
        date_end: '',
        customer_id: ''
    }) {
        return await allFetch('MOSReport/DateRangeCustomerTotalDetail', obj);
    }
    /**
     * @description 期間品項統計
     */
    const DateRangeCustomerByDayDetail = async function (obj = {
        Plant: '',
        date_start: '',
        date_end: '',
        customer_id: ''
    }) {
        return await allFetch('MOSReport/DateRangeCustomerByDayDetail', obj);
    }
    /**
     * @description 查出日期區間有點餐的員工
     */
    const DateRangeEmployeeTotal = async function (obj = {
        Plant: '',
        date_start: '',
        date_end: '',
        name: '',
        username: '',
        excel: ""
    }) {
        return await allFetch('MOSReport/DateRangeEmployeeTotal', obj);
    }
    /**
     * @description 查出日期區間有點餐的員工的餐點明細
     */
    const DateRangeEmployeeTotalDetail = async function (obj = {
        Plant: '',
        date_start: '',
        date_end: '',
        name: '',
        username: '',
        user_id: '',
        excel: ''
    }) {
        return await allFetch('MOSReport/DateRangeEmployeeTotalDetail', obj);
    }
    /**
     * @description 統計期間員工按點餐&已讀服務鈴次數
     */
    const DateRangeServiceTotal = async function (obj = {
        Plant: '',
        date_start: '',
        date_end: ''
    }) {
        return await allFetch('MOSReport/DateRangeServiceTotal', obj);
    }
    /**
     * @description 統計期間員工按點餐&已讀服務鈴次數
     */
    const DateRangeServiceDetail = async function (obj = {
        Plant: '',
        date_start: '',
        date_end: '',
        user_id: '',
        excel: ''
    }) {
        return await allFetch('MOSReport/DateRangeServiceDetail', obj);
    }
    return {
        DateRangeCustomerTotal,
        DateRangeMealServiceBellCheckCarCondition,
        DateRangeTotal,
        DateRangeCustomerByDayDetail,
        DateRangeCustomerTotalDetail,
        DateRangeEmployeeTotal,
        DateRangeEmployeeTotalDetail,
        DateRangeServiceTotal,
        DateRangeServiceDetail
    }
})();